import * as React from 'react';
import { Step } from '@pry-financials/react-joyride'

const stepsCelTarget = (view: 'cards' | 'list', mode: 'cps' | 'prek'): { [key: string]: string } => {
    return {
        stepCompare: view === 'cards' ? `.result-card .result-card-actions label` : `${mode === 'cps' ? '.cps' : '.cel-prek'} .result-card-actions label`,
        stepMoreInfo: view === 'cards' ? `.result-card .header` : `${mode === 'cps' ? '.cps' : '.cel-prek'} .links a`
        };
}

export function getSteps(mode, cardView): Step[] {
    const stepsCel: Step[] = [
        {
            target: ".search-form",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Start Your Search for Schools</h3>
                    <div className="tour_body">
                        <ul className="body_list">
                            <li>Enter your address, a zip code or a neighborhood to find schools in those areas.</li>
                            <li>Enter a school name to find a particular school.</li>
                            {/* <li>Click and hold on the map for 2 seconds to drop a pin and search for schools. </li> */}
                        </ul>
                    </div>

                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 1 */

        {
            target: ".search-filters .filters-handle ",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Filters</h3>
                    <div className="tour_body">
                        <p>Filter results to narrow your search.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            placement: 'right-start',
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 2 */

        {
            target: stepsCelTarget(cardView, mode).stepCompare,
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Compare</h3>
                    <div className="tour_body">
                        <ul className="body_list">
                            <li>Click the compare box to add this school to the list of schools to be compared.</li>
                            <li>Click the Compare button in the results bar above to bring up the compare information for the checked schools.</li>
                        </ul>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 5,
            hideCloseButton: true,
        }, /* Step 3 */

        {
            target: stepsCelTarget(cardView, mode).stepMoreInfo,
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">More Info</h3>
                    <div className="tour_body">
                        <p>Click this button to view additional information in the school detail page.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 4 */

        {
            target: ".card-reset-btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Reset Map</h3>
                    <div className="tour_body">
                        <p>Click this button to reset the map.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 5 */

        {
            target: ".search_near_me",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Schools Near Me</h3>
                    <div className="tour_body">
                        <p>This button attempts to locate you and searches for schools around you. You must allow your current location to be sent in order for this feature to work.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 6 */

        {
            target: ".expand_nav_btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Expand/Contract</h3>
                    <div className="tour_body">
                        <p>Expand the map to fill the browser window. Contract the map to regain access to the header, menus, and footer of the page.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 7 */

        {
            target: ".view-buttons",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">View Mode</h3>
                    <div className="tour_body">
                        <p>Toggle between Card and List view.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 8 */

        {
            target: ".search-overlays-btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Overlays</h3>
                    <div className="tour_body">
                        <p>Overlays appear on top of the existing map to help denote specific boundaries or regions.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 9 */

        {
            target: ".search_legend_btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Map Legend</h3>
                    <div className="tour_body">
                        <p>The legend describes the items on the map.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 10 */

        {
            target: ".help-btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Help</h3>
                    <div className="tour_body">
                        <p>Help includes information and the link to the tour.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 11 */
    ];

    const steps: Step[] = [
        {
            target: ".search-form",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Start Your Search for Schools</h3>
                    <div className="tour_body">
                        <ul className="body_list">
                            <li>Enter your address, a zip code or a neighborhood to find schools in those areas.</li>
                            <li>Enter a school name to find a particular school.</li>
                            {/* <li>Click and hold on the map for 2 seconds to drop a pin and search for schools. </li> */}
                        </ul>
                    </div>

                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 1 */

        {
            target: ".search-filters .filters-handle ",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Filters</h3>
                    <div className="tour_body">
                        <p>Filter results to narrow your search. </p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            placement: 'right-start',
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 2 */

        {
            target: stepsCelTarget(cardView, mode).stepCompare,
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Compare</h3>
                    <div className="tour_body">
                        <ul className="body_list">
                            <li>Click the compare box to add this school to the list of schools to be compared.</li>
                            <li>Click the Compare button in the results bar above to bring up the compare information for the checked schools.</li>
                        </ul>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 5,
            hideCloseButton: true,
        }, /* Step 3 */

        {
            target: stepsCelTarget(cardView, mode).stepMoreInfo,
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">More Info</h3>
                    <div className="tour_body">
                        <p>Click this button to view additional information in the School Profile.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 4 */

        {
            target: ".card-reset-btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Reset Map</h3>
                    <div className="tour_body">
                        <p>Click this button to reset the map.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 5 */

        {
            target: ".search_near_me",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Schools Near Me</h3>
                    <div className="tour_body">
                        <p>This button attempts to locate you and searches for schools around you. You must allow your current location to be sent in order for this feature to work.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 6 */

        {
            target: ".expand_nav_btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Expand/Contract</h3>
                    <div className="tour_body">
                        <p>Expand the map to fill the browser window. Contract the map to regain access to the header, menus, and footer of the page.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 7 */

        {
            target: ".view-buttons",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">View Mode</h3>
                    <div className="tour_body">
                        <p>Toggle between Card and List view.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 8 */

        {
            target: ".search-overlays-btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Overlays</h3>
                    <div className="tour_body">
                        <p>Overlays appear on top of the existing map to help denote specific boundaries or regions.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 9 */

        {
            target: ".search_legend_btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Map Legend</h3>
                    <div className="tour_body">
                        <p>The legend describes the items on the map.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 10 */

        {
            target: ".help-btn",
            content: (
                <div className="tour_card">
                    <h3 className="tour_title">Help</h3>
                    <div className="tour_body">
                        <p>Help lists important phone numbers for attendance boundary and enrollment questions, Frequently Asked Questions, and a downloadable PDF of the map.</p>
                    </div>
                </div>
            ),
            disableBeacon: true,
            offset: 1,
            showSkipButton: true,
            spotlightPadding: 0,
            hideCloseButton: true,
        }, /* Step 11 */
    ];

    return mode === 'cps' ? steps : stepsCel
}

